/**
 * Returns true if any node has parameterInput containing live_corpus_id that is empty string.
 * Used to know when to keep subscription open for backend updates.
 */
export function hasRowWithEmptyLiveCorpusId(
  nodes: Array<{ parameterInput?: string | object | null }> | null | undefined
): boolean {
  if (!nodes || !Array.isArray(nodes)) return false;
  for (const node of nodes) {
    const raw = node?.parameterInput;
    if (raw == null) continue;
    let obj: Record<string, unknown>;
    try {
      obj =
        typeof raw === 'string'
          ? JSON.parse(raw)
          : (raw as Record<string, unknown>);
    } catch {
      continue;
    }
    if (
      obj &&
      typeof obj === 'object' &&
      'live_corpus_id' in obj &&
      obj.live_corpus_id === ''
    ) {
      return true;
    }
  }
  return false;
}
